var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22615_107605)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.9375C13.4498 0.9375 17.0625 4.55025 17.0625 9C17.0625 13.4498 13.4498 17.0625 9 17.0625C4.55025 17.0625 0.9375 13.4498 0.9375 9C0.9375 4.55025 4.55025 0.9375 9 0.9375ZM12.4343 8.46825L7.6455 5.856C7.458 5.754 7.23 5.75775 7.04625 5.86725C6.8625 5.976 6.75 6.174 6.75 6.38775V11.6123C6.75 11.826 6.8625 12.024 7.04625 12.1328C7.23 12.2423 7.458 12.246 7.6455 12.144L12.4343 9.53175C12.6293 9.42525 12.75 9.22125 12.75 9C12.75 8.77875 12.6293 8.57475 12.4343 8.46825Z",
    fill: "#296BCD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22615_107605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e6db217e5ed72a4ba4185c3c94c6f8b5.svg";
export { ForwardRef as ReactComponent };